import styled, { css } from 'styled-components';
import { withQuery, select } from '@panel/commons/core/themev2';
import { getNeutralColors } from '@panel/commons/lib/theme';
import buttonCheckbox from '@panel/commons/assets/icons/buttom_checkbox.svg';
import buttonCheckboxSelected from '@panel/commons/assets/icons/button_checkbox_selected.svg';
import AlertCircleBlue from '@panel/commons/assets/icons/AlertCircleBlue.svg';
import iconPhone from '../../../../assets/img/phoneIcon.svg';
import iconSmartphone from '../../../../assets/img/smartphoneIcon.svg';

const PreviewSection = styled.div`
  margin-bottom: 40px;
  > p {
    color: ${select('midDarkGray')};
    margin-bottom: 20px;
  }
  ${withQuery.md.down()} {
    margin-top: 20px;
  }
`;
const PreviewContainer = styled.div`
  margin: 0 auto;
  display: flex;
  border-radius: 12px;
  border: solid 1px ${select('midLightGray')};
  background-color: ${select('white')};
  box-sizing: border-box;
  overflow: hidden;
  ${withQuery.lg.down()} {
    max-height: 520px;
  }
  ${withQuery.sm.down()} {
    flex-direction: column;
    height: auto;
    max-height: 550px;
  }
`;
const PostingImageWrapper = styled.div`
  width: 334px;
  height: 246px;
  position: relative;
  ${withQuery.md.up()} {
    min-width: 35%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  ${withQuery.md.down()} {
    width: 100%;
    height: 262px;
  }
`;

const Pill = styled.span`
  display: block;
  position: absolute;
  height:26px;
  ${({ top }) => top && `top: ${top}px`};
  ${({ right }) => right && `right: ${right}px`};
  ${({ bottom }) => bottom && `bottom: ${bottom}px`};
  ${({ left }) => left && `left: ${left}px`};
  padding: 2px 6px;
  border-radius: 21px;
  ${({ foreGroundColor = 'white' }) => `background-color: ${select(foreGroundColor)}`}
  ${({ color = 'black' }) => `color: ${select(color)}`}
  ${({ borderColor }) => borderColor && `border: 1px solid ${select(borderColor)}`}
  font-size: 12px;
  letter-spacing: normal;
  &.FREE {
    background-color: ${select('midDarkGray')};
    color: white;
  }
  &.SIMPLE {
    background-color: #FFDB5E;
    border-color: #FFDB5E;
    color: black;
  }
  &.HIGHLIGHTED {
    background-color: #34BE34;
    border-color: #34BE34;
    color: white;
  }
  &.SUPERHIGHLIGHTED {
    background-color: #3A0C3D;
    border-color: #3A0C3D;
    color: white;
  }
  ${withQuery.lg.down()} {
   top:8px;
  }
  ${withQuery.md.down()} {
    top:3px;
   }
   ${withQuery.sm.down()} {
    top:auto;
   }
`;

const PostingInfoWrapper = styled.div`
  ${props => props.minWidth && 'min-width:440px'};
  width: 100%;
  height: 246px;
  background-color: ${select('white')};
  position: relative;
  padding: 15px 20px;
  ${withQuery.lg.down()} {
    width: 65%;
    padding: 10px 15px;
  }
  ${withQuery.md.down()} {
    width: 100%;
    margin-top: 20px;
  }
`;

const BlockInfo = styled.div`
  display: flex;
  flex-direction: ${props => props.layout};
  margin-bottom: 10px;
  box-sizing: border-box;
  ${({ content }) => content && `justify-content: ${content}`};
  ${withQuery.md.down()} {
    margin-bottom: 0px;
  }
`;

const Rates = styled.div`
  display: flex;
  padding-right: 25px;
  min-width: 170px;
  border-right: 1px solid ${select('midLightGray')};
  flex-direction: column;
  h2 {
    margin-bottom: 0;
    padding-bottom: 0;
    font-size: 20px;
    font-weight: 600;
  }
  p {
    color: ${select('midDarkGray')};
    font-size: 14px;
    font-weight: normal;
  }
  ${withQuery.lg.down()} {
    padding-right: 10px;
    h2 {
      font-size: 16px;
      font-weight: 600;
    }
    p {
      color: ${select('midDarkGray')};
      font-size: 14px;
      font-weight: normal;
      margin-bottom: 0px;
    }
  }
  ${withQuery.md.down()} {
    border-right: none;
    h2 {
      font-size: 12px;
      &.price {
        font-size: 16px;
        font-weight: 600;
      }
    }
    p {
      font-size: 12px;
      margin-bottom: 10px;
    }
  }
`;

const AddressContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 70%;
`;

const AddressBox = styled(Rates)`
  border-right: none;
  padding-left: 10px;
  width: ${({ plan }) => (plan === 'FREE' ? '75%' : '62%')};
  h2 {
    text-overflow: ellipsis;
    overflow: hidden;
  }
  p {
    max-width: 360px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  ${withQuery.md.down()} {
    font-size: 12px;
    padding-left: 0px;
    width: 60%;
    min-width: 100px;
  }
`;

const FeaturesBox = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  font-size: 14px;
  > div {
    display: flex;
    align-items: center;
  }
  svg {
    margin-right: 5px;
  }
  span {
    margin-right: 15px;
    font-family: 'Hind';
  }
  margin-bottom: 10px;
  ${withQuery.md.down()} {
    svg {
      margin-right: 3px;
    }
    font-size: 12px;
    span {
      margin-right: 5px;
      font-family: 'Hind';
    }
  }
  ${withQuery.xs.down()} {
    flex-flow: row wrap;
    svg {
      margin-right: 2px;
    }
    span {
      margin-right: 3px;
      font-family: 'Hind';
    }
  }
`;

const PostingTitle = styled.h2`
  font-size: 14px;
  font-weight: 600;
  color: ${select('black')};
  ${withQuery.md.down()} {
    font-size: 12px;
    margin-bottom: 10px;
  }
`;

const PostingDescription = styled.p`
  color: ${select('midDarkGray')};
  width: 516px;
  padding-bottom: 10px;
  border-bottom: 1px solid ${select('midLightGray')};
  overflow: hidden;
  padding-right: 40px;
  white-space: normal;
  text-overflow: ellipsis;
  ${withQuery.lg.down()} {
    width: calc(100% + 30px);
    margin-bottom: 0px !important;
    padding-right: 30px;
  }
  ${withQuery.md.down()} {
    font-size: 12px;
    margin-left: -15px;
    padding-left: 15px;
    padding-right: 15px;
  }
  ${withQuery.xs.down()} {
    padding-right: 20px;
    border-bottom: 0px;
  }
`;

const PublisherInfo = styled.div`
  color: ${select('midDarkGray')};
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  font-size: 16px;
  ${withQuery.lg.down()} {
    font-size: 14px;
  }
  ${withQuery.md.down()} {
    font-size: 14px;
    margin-top: 20px;
  }
  img {
    width: 56px;
    height: 30px;
    margin-right: 10px;
  }
  span {
    font-family: 'Hind';
  }
`;

const Body = styled.div`
  padding: 40px 40px 45px;
  font-family: 'Hind';
  ${withQuery.md.down()} {
    padding: 10px 16px;
  }
`;

const Title = styled.h2`
  font-size: 2rem;
  margin-bottom: 8px;
  white-space: normal;
`;

const SubTitle = styled.h3`
  font-weight: normal;
  font-size: 1.4rem;
  font-family: 'Hind';
  color: ${select('midDarkGray')};
  margin-bottom: 27px;
  ${withQuery.md.down()} {
    font-size: 1.3rem;
  }
`;

const ContactInfoTitle = styled.p`
  margin: 5px 0;
  color: ${select('midDarkGray')};
`;

const ContactInfoField = styled.div`
  background-color: ${select('lightGray')};
  color: ${select('midDarkGray')};
  line-height: 48px;
  padding: 0px 12px;
  border-radius: 8px;
  max-width: 423px;
  width: 100%;

  ${withQuery.xs.down()} {
    max-width: 392px;
    margin-bottom: 24px;
  }
`;

const ContactInfoContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;

  ${withQuery.sm.down()} {
    flex-direction: column;
    margin-bottom: 0;
  }
`;

const ContactInfo = styled.div`
  background: ${select('white')};
  border: 1px solid ${select('midLightGray')};
  border-radius: 12px;
  width: 504px;
  display: flex;
  align-items: center;
  margin-right: 40px;
  ${withQuery.sm.down()} {
    width: 100%;
    margin-right: 0;
    margin-bottom: 20px;
  }
`;

const ContactInfoLogo = styled.div`
  width: fit-content;
  height: fit-content;
  display: flex;
  padding: 10px;
  ${withQuery.sm.down()} {
    padding: 0px;
  }
`;

const ContactInfoData = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  ${withQuery.sm.down()} {
    margin-left: 16px;
  }
`;

const ContactInfoDataName = styled.p`
  font-weight: 600;
  font-size: 20px;
  line-height: 130%;
  color: ${getNeutralColors('grisOscuroAccesible')};
  ${withQuery.sm.down()} {
    font-weight: 500;
    font-size: 16px;
  }
`;

const ContactInfoDataPhone = styled.div`
  margin-top: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  white-space: normal;

  &:before {
    content: '';
    vertical-align: text-top;
    width: 24px;
    height: 24px;
    margin-right: 9px;
    position: absolute;
    background-image: ${({ mobile }) => `url(${mobile ? iconSmartphone : iconPhone})`};
    background-repeat: no-repeat;
    top: 2px;
    ${withQuery.xs.down()} {
      align-items: baseline;
    }
  }

  p {
    font-size: 16px;
    line-height: 25.62px;
    margin-left: 33px;
  }
`;

const ContactInformationMessage = styled.div`
  height: fit-content;
  width: 324px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 12px;
  background-color: ${select('lightGray')};
  border: 1px solid ${select('midLightGray')};
  border-left: 4px solid ${select('blue')};
  border-radius: 4px;
  white-space: normal;

  &:before {
    content: '';
    vertical-align: text-top;
    width: 16px;
    height: 16px;
    margin-right: 9px;
    position: absolute;
    background-image: url(${AlertCircleBlue});
    background-repeat: no-repeat;
    top: 16px;
    ${withQuery.xs.down()} {
      align-items: baseline;
      top: 16px;
    }
  }

  p {
    margin-left: 25px;
  }

  ${withQuery.sm.down()} {
    width: 100%;
    margin-bottom: 24px;
  }
`;

const UpdatePersonalDataCheckBox = styled.div`
  height: auto;
  width: 57%;
  margin: 0px;
  line-height: 40px;
  position: relative;
  input {
    display: none;
  }
  label {
    cursor: pointer;
    > span {
      display: inline-block;
      line-height: 30px;
      vertical-align: top;
      ${withQuery.xs.down()} {
        font-size: 16px;
      }
    }
  }
  label > span:before {
    display: inline-block;
  }
  label > span:before {
    margin-right: 8px;
    position: relative;
    top: 3px;
    content: '';
    width: 16px;
    height: 16px;
    background-image: url(${buttonCheckbox});
  }
  input:checked + span:before {
    content: '';
    width: 16px;
    height: 16px;
    background-image: url(${buttonCheckboxSelected});
  }
`;

export {
  Body,
  Title,
  Pill,
  SubTitle,
  ContactInfoTitle,
  ContactInfoField,
  ContactInfoContainer,
  ContactInfo,
  ContactInfoLogo,
  ContactInfoData,
  ContactInfoDataName,
  ContactInfoDataPhone,
  ContactInformationMessage,
  UpdatePersonalDataCheckBox,
  PreviewSection,
  PreviewContainer,
  PostingImageWrapper,
  PostingInfoWrapper,
  BlockInfo,
  Rates,
  AddressBox,
  FeaturesBox,
  PostingTitle,
  PostingDescription,
  PublisherInfo,
  AddressContainer
};
